export default __webpack_public_path__ + "static/media/logo.56101f16.svg";